import { render, staticRenderFns } from "./ViewDocument.vue?vue&type=template&id=dd5cdb98&scoped=true&"
import script from "./ViewDocument.ts?vue&type=script&lang=ts&"
export * from "./ViewDocument.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd5cdb98",
  null
  
)

export default component.exports